import { HomeIcon, PlusCircleIcon } from '@heroicons/react/24/outline';
import { ActionButton } from '@library/components/buttons';
import { PageHeader } from '@library/components/layout/PageHeader';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export interface ResolutionsHeaderProps {
  isHomePage?: boolean;
  disableCreateResolution?: boolean;
  title: string;
}

export const ResolutionsHeader = ({
  isHomePage = false,
  disableCreateResolution = false,
  title
}: ResolutionsHeaderProps) => {
  const navigate = useNavigate();
  const navLink = useMemo(() => {
    return isHomePage ? (
      <ActionButton
        dataTestId="create-new-resolution"
        disabled={disableCreateResolution}
        handleOnClick={() => navigate('/resolutions/new')}
        title="Create new resolution"
      >
        <PlusCircleIcon className="text-soClean-100 mr-2 size-5" />
        <span>Create new resolution</span>
      </ActionButton>
    ) : (
      <ActionButton
        dataTestId="return-to-resolutions-home"
        handleOnClick={() => navigate('/resolutions')}
        variant="secondary"
        title="Return to Resolutions"
      >
        <HomeIcon className="text-soClean-100 mr-2 size-4" />
        <span>Return to home</span>
      </ActionButton>
    );
  }, [disableCreateResolution, isHomePage, navigate]);

  return (
    <PageHeader moduleName="Resolutions" title={title}>
      {navLink}
    </PageHeader>
  );
};
